import {
  FETCH_SUPERVISOR_WISE_OT_REQUEST,
  FETCH_SUPERVISOR_WISE_OT_SUCCESS,
  FETCH_SUPERVISOR_WISE_OT_FAILURE,
} from "../constants/SupervisorWiseOTConstants";

import SupWiseService from "../service/SupervisiorWiseOTService";

export const fetchSupWiseOT = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }

  try {
    dispatch({ type: FETCH_SUPERVISOR_WISE_OT_REQUEST });

    const data = await SupWiseService.getAll(date);

    dispatch({
      type: FETCH_SUPERVISOR_WISE_OT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SUPERVISOR_WISE_OT_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};


